<template>
  <el-dialog
    title="用户详情"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane label="基本信息" name="basic">
        <el-form label-width="120px" label-position="left">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司名称：">
                <span>{{ userData.company_name || '无' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：">
                <span>{{ userData.mobile || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="平台名称：">
                <span>{{ userData.app_name || '无' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道商：">
                <span>{{ channelName || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="价格方案：">
                <span>{{ userData.price_name || '无' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册时间：">
                <span>{{ formatDate(userData.created_at) || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="账户状态：">
                <el-tag :type="userData.disabled ? 'danger' : 'success'">
                  {{ userData.disabled ? '锁定' : '正常' }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="账户信息" name="account">
        <el-form label-width="180px" label-position="left">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="总充值金额：">
                <span>{{ formatMoney(userData.deposit) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消费金额：">
                <span>{{ formatMoney(userData.expense) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="账户余额：">
                <span>{{ formatMoney(userData.balance) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已开发票金额：">
                <span>{{ formatMoney(userData.invoice) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="线下充值总金额：">
                <span>{{ formatMoney(userData.offline_deposit) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="线下充值支出总金额：">
                <span>{{ formatMoney(userData.offline_expense) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="线下充值当前余额：">
                <span>{{ formatMoney(userData.offline_balance) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="鼎盛当前余额：">
                <span>{{ formatMoney(userData.ds_balance) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="用户收件地址" name="address">
        <el-table
          :data="addressList"
          border
          v-loading="addressLoading"
        >
          <el-table-column prop="recipients" label="收件人" align="center" width="120"></el-table-column>
          <el-table-column prop="mobile" label="收件人手机号" align="center" width="130"></el-table-column>
          <el-table-column prop="phone" label="座机" align="center" width="130"></el-table-column>
          <el-table-column label="详细地址" align="center">
            <template slot-scope="scope">
              {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}{{ scope.row.street }}
            </template>
          </el-table-column>
          <el-table-column prop="is_primary" label="默认地址" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_primary ? '是' : '否' }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { getUserAddressList, getHyxUserInfo } from '@/api/member'

export default {
  name: 'UserDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      activeTab: 'basic',
      addressLoading: false,
      addressList: []
    }
  },
  computed: {
    channelName() {
      if (this.userData.channel_name && this.userData.alias) {
        return `${this.userData.channel_name}(${this.userData.alias})`
      } else if (this.userData.alias) {
        return this.userData.alias
      } else {
        return '无'
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        // 获取用户收件地址
        this.fetchUserAddress()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    formatDate,
    formatMoney,
    // 获取用户收件地址
    async fetchUserAddress() {
      this.addressLoading = true
      try {
        // 调用获取用户收件地址的API
        const res = await getUserAddressList({ id: this.userId })
        if (res.err_code === 0) {
          this.addressList = res.rows || []
        } else {
          console.error('获取用户收件地址失败:', res.err_msg)
          this.$message.error('获取用户收件地址失败: ' + res.err_msg)
        }
      } catch (error) {
        console.error('获取用户收件地址失败:', error)
        this.$message.error('获取用户收件地址失败: ' + error.message)
      } finally {
        this.addressLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>